import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

const ConversationFilter = ({
  unreadOnly,
  onFilterChange,
  onSearchChange,
  onGroupFilterChange,
  filtersForGroups,
  filtersForGroupsReady,
}) => {
  const { t } = useTranslation();
  // Controlled by the parent (URL-driven) so the UNREAD tab can be deep-linked into.
  const showAll = !unreadOnly;
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [groupOptions, setGroupOptions] = useState([]);

  useEffect(() => {
    if (!filtersForGroups) return;

    const options = [
      {
        label: t('communication.recipientsGroups'),
        options: filtersForGroups.groups?.map(g => ({
          value: `group_${g.value}`, label: g.label,
        })) || [],
      },
      {
        label: t('communication.recipientsSubgroups'),
        options: filtersForGroups.subgroups?.map(g => ({
          value: `subgroup_${g.value}`, label: g.label,
        })) || [],
      },
      {
        label: t('communication.recipientsCohorts'),
        options: filtersForGroups.cohorts?.map(g => ({
          value: `cohort_${g.value}`, label: g.label,
        })) || [],
      },
    ];
    setGroupOptions(options);
  }, [filtersForGroups]);

  const onShowAll = (toShow) => {
    onFilterChange(!toShow);
  }

  const handleGroupChange = (selected) => {
    onGroupFilterChange(selected || []);
  };

  const renderGroupSelect = () => {
    return (
      <div className='o-communication__conversation-filter-groups'>
        <Select
          name='sp-conversation-group-filter'
          className='o-select--optgroup'
          isMulti={true}
          options={groupOptions}
          onChange={handleGroupChange}
          placeholder={t('communication.filterByGroup')}
          noOptionsMessage={() => t('communication.noOptions')}
          isDisabled={!filtersForGroupsReady}
          isClearable={true}
        />
      </div>
    );
  };

  const [searchValue, setSearchValue] = useState('');

  const handleSearchInput = (e) => {
    setSearchValue(e.target.value);
    onSearchChange(e.target.value);
  };

  const handleSearchClear = () => {
    setSearchValue('');
    onSearchChange('');
  };

  const renderSearchBar = () => {
    return (
      <div className="o-communication__conversation-filter-search">
        <i className="o-communication__conversation-filter-search--icon fa fa-search"></i>
        <input
          type="text"
          className="o-communication__conversation-filter-search--input"
          placeholder={t('communication.searchPlaceholder')}
          value={searchValue}
          onChange={handleSearchInput}
        />
        {searchValue && (
          <i
            className="o-communication__conversation-filter-search--clear fa fa-times"
            onClick={handleSearchClear}
          />
        )}
      </div>
    );
  }


  return (
    <div className="o-communication__conversation-filter">
      <div className="o-communication__filter-tabs">
        <button
          className={classNames('o-communication__filter-tab', { 'o-communication__filter-tab--active': showAll })}
          onClick={() => onShowAll(true)}>
          {t('communication.filter.all')}
        </button>
        <button
          className={classNames('o-communication__filter-tab', { 'o-communication__filter-tab--active': !showAll })}
          onClick={() => onShowAll(false)}>
          {t('communication.filter.unread')}
        </button>
        <button
          className={classNames('o-communication__filter-toggle', { 'o-communication__filter-toggle--active': filtersOpen || searchValue })}
          onClick={() => setFiltersOpen(o => !o)}
          title="Filters">
          <i className="fa fa-filter" aria-hidden="true"></i>
          {searchValue && <span className="o-communication__filter-toggle-dot"></span>}
        </button>
      </div>
      {filtersOpen && (
        <div className="o-communication__filter-panel">
          {renderGroupSelect()}
          {renderSearchBar()}
        </div>
      )}
    </div>
  )
};

ConversationFilter.propTypes = {
  unreadOnly: PropTypes.bool,
  onFilterChange: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onGroupFilterChange: PropTypes.func.isRequired,
  filtersForGroups: PropTypes.object,
  filtersForGroupsReady: PropTypes.bool,
};

const mapStateToProps = _state => ({});

export default connect(mapStateToProps, {})(ConversationFilter);
